export const auth0EndpointConfig = [
  {
    endpoint: '/subscription/v1/subscriptions/article',
    audience: 'https://digitalapi.auspost.com.au/medium',
    scope: 'https://scopes.auspost.com.au/auth/mpc/track.readwrite',
  },
  {
    endpoint: '/mypostredirect/session',
    audience: 'https://digitalapi.auspost.com.au/high',
    scope: 'https://scopes.auspost.com.au/auth/mpc/redirect.readwrite',
  },
  {
    endpoint: '/delivery-preferences/v2/preferences',
    audience: 'https://digitalapi.auspost.com.au/medium',
    scope: 'https://scopes.auspost.com.au/auth/mpc/consumer.readwrite',
  },
  {
    method: 'GET',
    endpoint: '/shipments-gateway/v1/watchlist/shipments',
    audience: 'https://digitalapi.auspost.com.au/medium',
    scope: 'https://scopes.auspost.com.au/auth/mpc/track.readwrite',
    allowAnon: true,
  },
  // shipmentsgateway request with PATCH/DELETE
  {
    endpoint: '/shipments-gateway/v1/watchlist/shipments',
    audience: 'https://digitalapi.auspost.com.au/medium',
    scope: 'https://scopes.auspost.com.au/auth/mpc/track.readwrite',
  },
];
